export const lang = {
	//titleชื่อเรื่องสําหรับแต่ละหน้า
	title: 'การปกป้องสิทธิ์ของแพลตฟอร์ม',
}